"use strict";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.line_chart_loop = void 0;
/* eslint-disable max-len */

var react_1 = __importDefault(require("react"));

var classnames_1 = __importDefault(require("classnames"));

var line_chart_loop = function line_chart_loop(_a) {
  var className = _a.className,
      rest = __rest(_a, ["className"]);

  var classes = (0, classnames_1["default"])('helix-icon', 'line-chart-loop-outlined', className);
  return react_1["default"].createElement("svg", Object.assign({
    className: classes,
    width: '20',
    height: '20',
    viewBox: '0 0 20 20',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg',
    "aria-hidden": 'true'
  }, rest), react_1["default"].createElement("path", {
    d: "M17.1606 3.95081C17.357 3.58611 17.2205 3.13126 16.8558 2.93488C16.4911 2.73851 16.0362 2.87496 15.8399 3.23966L13.009 8.49707C13.5775 8.35285 14.1643 8.35306 14.7195 8.48426L17.1606 3.95081Z",
    fill: "#4B5563"
  }), react_1["default"].createElement("path", {
    d: "M11.3164 9.47208L10.4952 8.65083L8.18671 13.8973C8.087 14.1239 7.88186 14.2867 7.63851 14.3324C7.39517 14.378 7.14497 14.3006 6.9699 14.1256L5.20569 12.3614L3.67105 15.4306C3.4858 15.8011 3.0353 15.9513 2.66482 15.7661C2.29433 15.5808 2.14416 15.1303 2.3294 14.7598L4.32941 10.7598C4.43722 10.5442 4.64212 10.3935 4.88009 10.3549C5.11806 10.3163 5.36008 10.3944 5.53056 10.5649L7.2553 12.2896L9.56374 7.04318C9.66345 6.81656 9.86859 6.65375 10.1119 6.6081C10.3553 6.56245 10.6055 6.63983 10.7806 6.81491L12.595 8.62933C12.4242 8.69556 12.2563 8.7757 12.0927 8.87013C11.8006 9.03877 11.5411 9.24217 11.3164 9.47208Z",
    fill: "#4B5563"
  }), react_1["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.558 9.67617C11.2816 10.4131 10.8443 12.0452 11.5812 13.3215C12.1879 14.3724 13.4014 14.8545 14.5236 14.5808L15.6888 16.5989L16.9878 15.8489L15.8227 13.8307C16.6208 12.9958 16.81 11.7038 16.2033 10.6529C15.4664 9.37657 13.8343 8.93926 12.558 9.67617ZM12.8802 12.5715C12.5575 12.0126 12.749 11.2979 13.308 10.9752C13.8669 10.6525 14.5816 10.844 14.9043 11.4029C15.227 11.9619 15.0355 12.6765 14.4765 12.9992C13.9176 13.3219 13.2029 13.1304 12.8802 12.5715Z",
    fill: "#4B5563"
  }));
};

exports.line_chart_loop = line_chart_loop;